import React from "react";
import { StyledAutocomplete } from "components/ui/form/styled-autocomplete";
import { SectionTitle } from "./common";
import { toneOfVoiceSuggestions } from "templates/shared-templates/common-fields";
import { useShortId } from "hooks/use-short-id";
import { Box } from "components/ui/box";
import { IconButton } from "components/ui/button";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Tooltip } from "components/ui/tooltip";
import { dashboardRouteConfig } from "client-server-shared/config/routes";
import { useTranslation } from "components/translate";

export const ToneOfVoicePlain = React.memo(
  ({
    title,
    onChange,
    onInputChange,
    placeholder,
    value,
    autoCompleteSuggestions,
    useInternalState,
    autoCompleteProps = {},
    showStyle = true,
    addStyle,
    optional,
    required,
    info,
    hideTitle,
  }) => {
    const { t } = useTranslation("templates");

    const [internalValue, setInternalValue] = React.useState(value || null);
    const onInternalValueChange = React.useCallback((event, value) => {
      setInternalValue(value.value);
    }, []);

    const onInternalInputChange = React.useCallback((event, value) => {
      setInternalValue(value);
    }, []);
    const id = useShortId();

    return (
      <>
        {hideTitle ? null : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <SectionTitle
              info={info}
              optional={optional}
              required={required}
              forId={id}
            >
              {title}
            </SectionTitle>
          </Box>
        )}
        <Box
          sx={{
            position: "relative",
          }}
        >
          <StyledAutocomplete
            id={id}
            disableClearButton
            options={autoCompleteSuggestions || toneOfVoiceSuggestions}
            onChange={useInternalState ? onInternalValueChange : onChange}
            onInputChange={
              useInternalState ? onInternalInputChange : onInputChange
            }
            placeholder={placeholder || ""}
            value={useInternalState ? internalValue : value}
            {...autoCompleteProps}
          />
          {showStyle ? (
            <Tooltip
              title={t("Add your own tones and Junia will write like you")}
            >
              <IconButton
                sx={{
                  position: "absolute",
                  right: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
                onClick={() => {
                  if (addStyle) {
                    addStyle();
                  }
                }}
              >
                <AddOutlinedIcon
                  sx={{
                    height: "16px",
                    width: "16px",
                    fill: "rgba(0, 0, 0, 0.5)",
                  }}
                />
              </IconButton>
            </Tooltip>
          ) : null}
        </Box>
      </>
    );
  }
);
